import React from 'react'

const Eye = ({ color = '#DC7B19', size = '20' }) => {
  return (
    <svg
      className={`h-${size} w-${size}`}
      fill={color}
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3878 18.2201C11.1638 18.2201 10.9398 18.135 10.7694 17.9635C9.90843 17.1036 9.43359 15.9603 9.43359 14.7446C9.43359 12.2246 11.4823 10.1748 13.9999 10.1748C15.2109 10.1748 16.3869 10.6636 17.2258 11.5165C17.5641 11.8618 17.5606 12.4148 17.2153 12.7531C16.8711 13.0938 16.3181 13.088 15.9786 12.745C15.4664 12.2235 14.7454 11.9248 13.9999 11.9248C12.4471 11.9248 11.1836 13.1895 11.1836 14.7446C11.1836 15.4925 11.4764 16.1971 12.0061 16.7268C12.3479 17.0686 12.3479 17.6216 12.0073 17.9635C11.8358 18.135 11.6118 18.2201 11.3878 18.2201Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6622 19.2395C14.248 19.2395 13.8793 18.9432 13.8023 18.5209C13.716 18.046 14.031 17.5899 14.507 17.5035C15.6503 17.2959 16.5557 16.3882 16.761 15.2437C16.8473 14.7689 17.3023 14.4562 17.7772 14.5379C18.2532 14.623 18.5693 15.078 18.4842 15.554C18.1493 17.4125 16.677 18.8872 14.8197 19.2255C14.7672 19.2349 14.7135 19.2395 14.6622 19.2395Z"
        fill={color}
      />
      <mask
        id="mask0_388_937"
        maskUnits="userSpaceOnUse"
        x="2"
        y="5"
        width="20"
        height="17"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.3335 5.39502H21.1008V21.8428H2.3335V5.39502Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_388_937)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.76375 21.8428C7.57475 21.8428 7.38458 21.781 7.22358 21.6562C5.25075 20.1068 3.58358 17.8353 2.40525 15.089C2.30958 14.8673 2.30958 14.6177 2.40525 14.3972C3.59641 11.6392 5.27408 9.356 7.25741 7.79617C11.3011 4.596 16.6841 4.5855 20.7686 7.8195C21.1477 8.11933 21.2119 8.67 20.9121 9.04917C20.6111 9.426 20.0627 9.4925 19.6824 9.1915C16.2221 6.45217 11.7642 6.4615 8.34125 9.1705C6.66591 10.4888 5.22741 12.4092 4.16575 14.7448C5.21691 17.0665 6.64258 18.9752 8.30508 20.2795C8.68541 20.5782 8.75075 21.1288 8.45208 21.508C8.27941 21.7273 8.02275 21.8428 7.76375 21.8428Z"
          fill={color}
        />
      </g>
      <mask
        id="mask1_388_937"
        maskUnits="userSpaceOnUse"
        x="10"
        y="10"
        width="16"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1704 10.1978H25.6667V24.1373H10.1704V10.1978Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_388_937)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0001 24.1373C12.907 24.1373 11.8196 23.96 10.7696 23.6112C10.3111 23.4583 10.0626 22.9625 10.2155 22.504C10.3683 22.0443 10.8618 21.8005 11.3226 21.9498C12.1941 22.2403 13.0948 22.3873 14.0001 22.3873C17.9995 22.3873 21.6546 19.5383 23.8351 14.7422C23.3031 13.5767 22.6836 12.5208 21.9906 11.5992C21.7001 11.213 21.7771 10.6635 22.1633 10.373C22.5483 10.0825 23.0978 10.1618 23.3883 10.5468C24.233 11.668 24.975 12.9642 25.5945 14.3945C25.6913 14.6162 25.6913 14.8682 25.5945 15.0887C23.1491 20.7552 18.815 24.1373 14.0001 24.1373Z"
          fill={color}
        />
      </g>
      <mask
        id="mask2_388_937"
        maskUnits="userSpaceOnUse"
        x="3"
        y="4"
        width="22"
        height="21"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.92432 4.66699H24.0767V24.8188H3.92432V4.66699Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_388_937)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.79902 24.8187C4.57502 24.8187 4.35102 24.7336 4.18069 24.5621C3.83886 24.2202 3.83886 23.6672 4.18069 23.3254L22.5837 4.92239C22.9255 4.58056 23.4785 4.58056 23.8204 4.92239C24.1622 5.26422 24.1622 5.81839 23.8204 6.16022L5.41736 24.5621C5.24702 24.7336 5.02302 24.8187 4.79902 24.8187Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default Eye
